import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=cce87144&scoped=true"
import script from "./BulkActions.vue?vue&type=script&lang=ts"
export * from "./BulkActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce87144",
  null
  
)

export default component.exports